import { useCallback, useMemo } from 'react'
import { HelpLauncher } from './HelpLauncher'
import {
  useFordeerAppsLauncherItem,
  useHelpCenterLauncherItem,
  useReferralProgramLauncherItem,
} from './HelpCenterFeature'
import { VirtualToursMenuGroup } from './VirtualToursMenuGroup'
import {
  useInvoiceWhatsNewController,
  useWhatsNewLauncherItem,
} from '@features/whats-new'
import { virtualTourAnalytics } from '@features/virtual-tour/analytics'
import { useVirtualTourFeature } from '@features/virtual-tour'

export const InvoiceHelpLauncher = () => {
  const whatsNewController = useInvoiceWhatsNewController()
  const whatsNewItem = useWhatsNewLauncherItem(whatsNewController)
  const helpCenterItem = useHelpCenterLauncherItem()
  const referralProgramItem = useReferralProgramLauncherItem()
  const virtualTour = useVirtualTourFeature()
  const fordeerAppsItem = useFordeerAppsLauncherItem()

  const items = useMemo(
    () =>
      [referralProgramItem, whatsNewItem, helpCenterItem, fordeerAppsItem]
        .filter((item) => !item.hidden)
        .sort(
          (a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER)
        ),
    [fordeerAppsItem, helpCenterItem, referralProgramItem, whatsNewItem]
  )

  const handleTourSelected = useCallback(
    (slug: string) => {
      const tour = virtualTour.tours.find((t) => t.slug === slug)
      if (tour) {
        virtualTourAnalytics.selected(
          tour.slug,
          tour.label,
          tour.order,
          virtualTour.tours.map((t) => t.slug),
        )
      }
    },
    [virtualTour.tours],
  )

  const renderVirtualToursGroup = useCallback(
    (closePopover: () => void) => {
      if (virtualTour.hidden || !virtualTour.tours.length) {
        return null
      }

      return (
        <VirtualToursMenuGroup
          tours={virtualTour.tours}
          onMenuExpanded={(count, slugs) => {
            virtualTourAnalytics.menuExpanded(count, slugs)
          }}
          onSelectTour={(slug) => {
            handleTourSelected(slug)
            closePopover()
            void virtualTour.startTourBySlug(slug)
          }}
        />
      )
    },
    [handleTourSelected, virtualTour]
  )

  return (
    <>
      <HelpLauncher
        items={items}
        onActivatorClick={whatsNewController?.dismissTeaser}
        renderVirtualToursGroup={renderVirtualToursGroup}
      />
      {virtualTour.node}
    </>
  )
}
